import React from 'react';

import { useTranslation } from 'hooks/useTranslation';
import { Title } from 'shared';

import { AuthPageLayout } from 'features/auth/components/AuthPageLayout';
import useAuth from 'features/auth/hooks/useAuth';
import { ChangePasswordForm } from 'features/auth/components/ChangePasswordForm';

import { useStyles } from './styles';

export const ResetPasswordPage = () => {
  const { t } = useTranslation('auth');
  const { onConfirmResetPassword, isLoading } = useAuth();
  const classes = useStyles();

  return (
    <>
      <Title title={t('resetPassword')} />
      <AuthPageLayout title={t('resetPassword')} additionalContentClassName={classes.passwordFormWrapper}>
        <ChangePasswordForm onFormSubmit={onConfirmResetPassword} isLoading={isLoading} />
      </AuthPageLayout>
    </>
  );
};
